import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Modal as AntdModal } from "antd";
import { Size } from "@type/sizing";
import { EnigmaTokens } from "@type/tokens";
import { Divider } from "@components/divider";
import { ModalProps } from "./modal.types";

const getButtonCss = (size) => {
    if (size === Size.large)
        return css`
            display: flex;
        `;
    return css`
        flex: 1;
    `;
};

const getContentpadding = (size) => {
    if (size === Size.large)
        return css`
            padding: 24px 24px 16px 24px;
        `;
    return css`
        padding: 24px;
    `;
};

export const StyledModal = styled(AntdModal)<
    ModalProps & { token: EnigmaTokens }
>`
    .enigma-modal-button {
        ${({ size }) => getButtonCss(size)}
        margin-inline-start: 0 !important;
    }
    .enigma-modal-footer {
        margin-top: 0px;
        display: flex;
        justify-content: space-between;
        gap: 12px;
        padding-top: ${({ size }) => (size === Size.large ? "16px" : "24px")};
    }
    .enigma-modal-header {
        margin-bottom: ${({ token }) => token.spacing.spacing50};
    }
    .enigma-modal-content {
        ${({ size }) => getContentpadding(size)}
    }
`;

export const StyledHeader = styled.div<{
    token: EnigmaTokens;
    closable: boolean;
}>`
    display: flex;
    justify-content: space-between;
    flex-direction: ${({ closable }) => (closable ? "row-reverse" : "row")};
    font-size: ${({ token }) => token.fontSizeLG}px;
`;

export const StyledDivider = styled(Divider)<{ token: EnigmaTokens }>`
    width: calc(100% + ${({ token }) => token.paddingLG * 2}px);
    margin: 0 0 0 -${({ token }) => token.paddingLG}px;
`;

export const StyledCancelButton = styled.span`
    cursor: pointer;
    display: inline-flex;
    align-items: flex-start;
    flex-shrink: 0;
`;

export const StyledTitle = styled.span`
    flex-grow: 1;
`;
